import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { AllTypeResourcesData } from "@/store/resources-grid/utils/types/resources";
import { gridResourcesCurrentCleanResourcesGroupedByExcludeIncludeSelector } from "@/store/resources-grid/selectors/clean/resources/gridResourcesCurrentCleanResourcesGroupedByExcludeIncludeSelector";

export const gridResourcesCurrentCleanResourcesSelector =
  createDraftSafeSelector(
    [gridResourcesCurrentCleanResourcesGroupedByExcludeIncludeSelector],
    (data): AllTypeResourcesData[] => {
      return data.included;
    },
  );
